/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Modal_Title1Inputs */

const en_support_submitticket_modal_title1 = /** @type {(inputs: Support_Submitticket_Modal_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit ticket`)
};

/**
* | output |
* | --- |
* | "Submit ticket" |
*
* @param {Support_Submitticket_Modal_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_modal_title1 = /** @type {((inputs?: Support_Submitticket_Modal_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Modal_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_modal_title1(inputs)
});
export { support_submitticket_modal_title1 as "support_submitTicket_modal_title" }